import externalServices from 'services/application/anchor/subServices/external';
import internalDynamicServices from 'services/application/anchor/subServices/internalDynamic';
import internalStaticServices from 'services/application/anchor/subServices/internalStatic';

export default {
	...externalServices,
	...internalDynamicServices,
	...internalStaticServices,
};
